import * as React from "react";

export type NativePlatformTarget = "all" | "ios" | "macos";

export type NativeControlRole =
  | "button"
  | "toolbar"
  | "toolbar-item"
  | "menu"
  | "menu-item"
  | "context-menu"
  | "search-field"
  | "text-field"
  | "date-field"
  | "text-area"
  | "select"
  | "popover"
  | "sheet"
  | "dialog"
  | "alert";

export type NativePresentation = "automatic" | "dialog" | "sheet" | "popover" | "alert";

export type NativeProminence = "normal" | "increased" | "reduced";

export interface NativeMetadataProps {
  nativeRole?: NativeControlRole;
  nativeAction?: string;
  nativeLabel?: string;
  nativeSymbol?: string;
  nativePresentation?: NativePresentation;
  nativeProminence?: NativeProminence;
  nativePlatform?: NativePlatformTarget;
}

export function splitNativeProps<T extends Record<string, any>>(props: T) {
  const {
    nativeRole,
    nativeAction,
    nativeLabel,
    nativeSymbol,
    nativePresentation,
    nativeProminence,
    nativePlatform,
    ...rest
  } = props;

  const nativeProps: React.HTMLAttributes<HTMLElement> & {
    'data-native-role'?: string;
    'data-native-action'?: string;
    'data-native-label'?: string;
    'data-native-symbol'?: string;
    'data-native-presentation'?: string;
    'data-native-prominence'?: string;
    'data-native-platform'?: string;
  } = {};

  if (nativeRole) nativeProps["data-native-role"] = nativeRole;
  if (nativeAction) nativeProps["data-native-action"] = nativeAction;
  if (nativeLabel) nativeProps["data-native-label"] = nativeLabel;
  if (nativeSymbol) nativeProps["data-native-symbol"] = nativeSymbol;
  if (nativePresentation) nativeProps["data-native-presentation"] = nativePresentation;
  if (nativeProminence) nativeProps["data-native-prominence"] = nativeProminence;
  if (nativePlatform && nativePlatform !== "all") {
    nativeProps["data-native-platform"] = nativePlatform;
  }

  return {
    nativeProps,
    rest: rest as Omit<T, keyof NativeMetadataProps>,
  };
}
